import { INavData } from "@coreui/angular-pro";

export const navItems: INavData[] = [
  {
    name: "Dashboard",
    url: "/dashboard",
    iconComponent: { name: "cil-speedometer" },
  },
  {
    name: "Prestaciones",
    url: "/prestaciones",
    iconComponent: { name: "cil-notes" },
  },
  {
    title: true,
    name: "Gestión",
  },
  {
    name: "Usuarios",
    iconComponent: { name: "cil-people" },
    children: [
      {
        name: "Usuarios",
        url: "/usuarios-admin",
        iconComponent: { name: "cil-people" },
      },
      {
        name: "Roles y permisos",
        url: "/roles-admin",
        iconComponent: { name: "cil-lock-locked" },
      },
    ],
  },
  {
    name: "Contenido",
    iconComponent: { name: "cil-description" },
    children: [
      {
        name: "Términos y Condiciones",
        url: "/terminos-admin",
        iconComponent: { name: "cil-description" },
      },
      {
        name: "Banners",
        url: "/banners-admin",
        iconComponent: { name: "cil-image" },
      },
      {
        name: "Catálogos de prestación",
        url: "/catalogos-prestacion",
        iconComponent: { name: "cil-list-rich" },
      },
    ],
  },
  {
    title: true,
    name: "Sistema",
  },
  {
    name: "Archivos",
    url: "/archivos-almacenamiento",
    iconComponent: { name: "cil-cloud-download" },
  },
  {
    name: "Incidentes IA",
    url: "/ia-incidentes",
    iconComponent: { name: "cil-warning" },
  },
  {
    name: "Tickets de ayuda",
    url: "/tickets-ayuda",
    iconComponent: { name: "cil-envelope-open" },
  },
  {
    name: "Membresías",
    url: "/membresias-admin",
    iconComponent: { name: "cil-credit-card" },
  },
  {
    title: true,
    name: "Operaciones",
  },
  {
    name: "Bandeja Operacional",
    url: "/bandeja-operacional",
    iconComponent: { name: "cil-list" },
  },
  {
    name: "Notificaciones",
    iconComponent: { name: "cil-bell" },
    children: [
      {
        name: "Envíos",
        url: "/notificaciones",
        iconComponent: { name: "cil-bell" },
      },
      {
        name: "Configuración",
        url: "/notificaciones/configuracion",
        iconComponent: { name: "cil-settings" },
      },
    ],
  },
];
